// extracted by mini-css-extract-plugin
module.exports = {"employee":"IB++M","employeeFilters":"+CBbT"};